import { Anotation } from './anotation';
import { NoAccents } from './noAccents.formatter';

export class PropName implements Anotation {
  name: string;
  constructor(value: string) {
    this.name = value;
  }

  validate(): boolean {
    const str = new NoAccents(this.name).format();
    // eslint-disable-next-line quotes, @typescript-eslint/quotes
    const regex = new RegExp("^[a-zA-Z]+[a-zA-Z'.\\s]*$");
    const result = regex.exec(str);
    if (!result) { return false; }
    return true;
  }
}
